import React, { useState, useEffect } from 'react';
import { FaPhone, FaWhatsapp, FaBars, FaTimes, FaSpa, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCall = () => {
    window.open('tel:+916204009260', '_self');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/916204009260?text=Hi, I would like to know more about your services', '_blank');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <FaSpa className={styles.logoIcon} />
          <div className={styles.logoText}>
            <span className={styles.logoName}>Sanaya Spa</span>
            <span className={styles.logoSubtext}>Noida</span>
          </div>
        </div>

        <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            <li><button onClick={() => scrollToSection('hero')} className={styles.navLink}>Home</button></li>
            <li><button onClick={() => scrollToSection('services')} className={styles.navLink}>Services</button></li>
            <li><button onClick={() => scrollToSection('about')} className={styles.navLink}>About</button></li>
            <li><button onClick={() => scrollToSection('gallery')} className={styles.navLink}>Gallery</button></li>
            <li><button onClick={() => scrollToSection('reviews')} className={styles.navLink}>Reviews</button></li>
            <li><button onClick={() => scrollToSection('contact')} className={styles.navLink}>Contact</button></li>
          </ul>
        </nav>

        <div className={styles.headerActions}>
          <div className={styles.contactInfo}>
            <div className={styles.infoItem}>
              <FaClock className={styles.infoIcon} />
              <span>24/7 Open</span>
            </div>
            <div className={styles.infoItem}>
              <FaMapMarkerAlt className={styles.infoIcon} />
              <span>Sector 62A, Noida</span>
            </div>
          </div>

          <div className={styles.actionButtons}>
            <button className={styles.callBtn} onClick={handleCall}>
              <FaPhone />
              <span className={styles.btnText}>Call</span>
            </button>
            <button className={styles.whatsappBtn} onClick={handleWhatsApp}>
              <FaWhatsapp />
              <span className={styles.btnText}>WhatsApp</span>
            </button>
          </div>

          <button className={styles.menuToggle} onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {isMenuOpen && <div className={styles.overlay} onClick={toggleMenu}></div>}
    </header>
  );
};

export default Header;